import { IDatasource, IServerSideDatasource } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { ConflictsApi } from "apis/ConflictsApi";
import { Title } from "components";
import { AgGrid } from "components/AgGrid/AgGrid";
import { ZSingleSelectDropdown } from "components/ZSingleSelectDropdown";
import { set } from "date-fns";
import { ManagedStockConflict } from "models/dbModels/conflicts/ManagedStockConflict";
import { StoreGroup } from "models/dbModels/storeGroups/StoreGroup";
import { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getStoreGroupsTable } from "redux/slices/StoreGroups";
import { RootState } from "redux/store";

export function Conflicts() {
    const dispatch = useAppDispatch();
    const storeGroups = useAppSelector((state: RootState) => state.storeGroups);
    const [selectedStoreGroup, setSelectedStoreGroup] = useState<StoreGroup | undefined>();
    const [rowData, setRowData] = useState<ManagedStockConflict[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getStoreGroups();
        getConflicts();
    }, [])

    function getStoreGroups() {
        dispatch(getStoreGroupsTable());
    }
    function getConflicts(storeGroupId: number | null = null) {
        setLoading(true);

        if (storeGroupId === null) {
            setRowData([]);
            setLoading(false);
            return;
        }
        else {
            ConflictsApi.managedStockConflictSearch({ storeGroups: [storeGroupId] }).then((response) => {
                setRowData(response.data.data);
            }).catch((error) => {
                setRowData([]);
            }).finally(() => {
                //Do nothing
                setLoading(false);
            });
        }
    }


    function gridDataSource(): IDatasource {
        return {
            getRows: (params) => {
                console.log("[Datasource] - rows requested by grid: ", params.context);

                if (!selectedStoreGroup) {
                    params.successCallback([], 0);
                    return;
                }
                else {
                    ConflictsApi.managedStockConflictSearch({ storeGroups: [selectedStoreGroup.id] }).then((response) => {
                        params.successCallback(response.data.data, response.data.totalRows);
                    }).catch((error) => {
                        params.failCallback();
                    }).finally(() => {
                        //Do nothing
                    });
                }
            },
        };
    }

    return (
        <div className="d-flex flex-column">
            <Title pageTitle="Conflicts" />
            <Card className="mt-3 d-flex vertical-align-center">
                <Card.Body style={{ height: '800px' }}>
                    <Row className="mt-2">
                        <Col md={6} >
                            <ZSingleSelectDropdown
                                label="Store Group"
                                options={storeGroups.table}
                                optionKey={(o) => o.id}
                                display={(o) => o?.name ?? ''}
                                value={selectedStoreGroup}
                                onSelectionChange={(o) => {
                                    setSelectedStoreGroup(o);
                                    if (o) {
                                        getConflicts(o.id);
                                    }
                                }}
                            />
                        </Col>
                    </Row >

                    <AgGrid
                        rowData={rowData}
                        columnDefs={[
                            { headerName: "Stock 1", field: "stockName1", sortable: true, filter: true },
                            { headerName: "Stock 2", field: "stockName2", sortable: true, filter: true },
                            { headerName: "Message", field: "message", sortable: true, filter: true, flex: 1 },
                        ]}
                        loading={loading}
                        heightPx={700}
                    />
                </Card.Body>
            </Card>
        </div >
    );
}
